<!--
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
-->
<template>
  <section
    v-if="isShowTitle()"
    :id="$style.Header"
    ref="Header"
    :class="$style.Header"
  >
    <button :class="$style['back-wrap']" @click="back">
      <Icon :class="$style['ico-back']" type="left" />
    </button>
    <span>
      {{ title }}
    </span>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Icon from '@src/commonComponents/Icon/index.vue'
import { getUtmSource } from '@util'
export default {
  components: {
    Icon,
  },
  props: {
    backAction: {
      type: Function,
    },
  },
  data() {
    return {
      source: [
        'anoffice',
        'wxminiprogram',
        'wechatwps',
        'wechath5',
        'iOSoffice',
        'qqminiprogram',
      ],
      title: '',
    }
  },
  computed: {
    ...mapState({
      s_title: state => state.HeadTitle,
    }),
  },
  watch: {
    s_title: function (newVal) {
      this.title = newVal
    },
  },
  mounted() {
    this.title = this.$store.state['HeadTitle']
  },
  methods: {
    back() {
      if (this.backAction) {
        this.backAction()
      } else {
        history.back()
      }
    },
    isShowTitle() {
      const utmSource = getUtmSource()
      if (
        this.source.includes(utmSource) ||
        navigator.userAgent.toLowerCase().includes('micromessenger')
      ) {
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss" module>
.Header {
  width: 100%;
  background: #fff;
  height: 88px;
  box-shadow: 0 2px 6px 0 hsla(0, 0%, 76.9%, 0.5);
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  color: #333;
  font-size: 36px;
  font-weight: 400;
  border-bottom: 1px solid rgba(235, 235, 235, 1);
}
.back-wrap {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  outline: none;
  border: none;
  background-color: transparent;
}
.ico-back {
  font-size: 28px;
}
</style>
